// ABOUTME: Apple brand mark for the OIDC sign-in button (uses currentColor).
// ABOUTME: Inline SVG icon component with size + className props.

import type { FC } from "react"

interface IconProps {
  size?: number
  className?: string
}

export const AppleIcon: FC<IconProps> = ({ size = 18, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.365 1.43c0 1.14-.417 2.2-1.11 2.98-.83.93-2.18 1.65-3.31 1.56-.14-1.12.42-2.3 1.1-3.02.77-.82 2.13-1.44 3.32-1.52zM20.9 17.02c-.55 1.27-.81 1.84-1.52 2.96-.99 1.56-2.39 3.5-4.12 3.51-1.54.01-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.01-3.05-1.76-4.04-3.32C.36 15.9-.14 11.36 1.87 8.72 2.99 7.22 4.79 6.28 6.5 6.28c1.74 0 2.84 1 4.28 1 1.4 0 2.25-1 4.27-1 1.53 0 3.15.83 4.3 2.27-3.78 2.07-3.17 7.46 1.55 8.47z" />
  </svg>
)
